import { MainContainer } from '@/components/atoms'
import { ExtendedConnectWalletButton } from '@/components/molecules'
import {
  History,
  ManageConsumers,
  ManageSingleSubscription,
} from '@/components/organisms'
import { Layout } from '@/components/templates'
import { useGetSubscription } from '@/hooks'
import { Heading, VStack } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import { useAccount } from 'wagmi'

export const SubscriptionPage = () => {
  const { subId: subIdFromParam } = useParams()
  const { isConnected } = useAccount()
  const {
    data: subscription,
    isLoading: isLoadingSub,
    refetch: refetchSub,
    isOwner,
  } = useGetSubscription(subIdFromParam)

  const { subId, consumers } = subscription || {}

  return (
    <Layout>
      <MainContainer>
        {isConnected ? (
          <VStack alignItems={'stretch'} spacing={8}>
            <Heading fontWeight={'500'} size={'lg'} textAlign={'center'}>
              {!isLoadingSub &&
                !isOwner &&
                `This Subscription doesn't belong to you`}
            </Heading>

            <ManageSingleSubscription
              refetchSub={refetchSub}
              showLoading={isLoadingSub || !isOwner}
              subscription={subscription}
            />

            {subId && (
              <History subId={subId} isLoading={isLoadingSub || !isOwner} />
            )}

            <ManageConsumers
              subId={subId}
              isLoading={isLoadingSub || !isOwner}
              refetchSub={refetchSub}
              consumers={consumers}
            />
          </VStack>
        ) : (
          <ExtendedConnectWalletButton
            maxW={400}
            text={'To Manage Subscription please connect to your wallet first.'}
          />
        )}
      </MainContainer>
    </Layout>
  )
}
